if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.initCutGroups();
        this.initMobileHeight();
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      initMobileHeight() {
        this.mobileSlide = this.elements.viewer.querySelector('.is-active');
        this.updateMobileHeight = () => {
          const slider = this.elements.viewer.querySelector('.product__media-list');
          const media = this.mobileSlide?.querySelector('.product-media-container');
          if (!slider || !media) return;
          const height = media.getBoundingClientRect().height;
          if (!this.mql.matches && height > 0) {
            slider.style.setProperty('--pk-active-media-height', Math.ceil(height) + 'px');
          } else {
            slider.style.removeProperty('--pk-active-media-height');
          }
        };
        this.elements.viewer.addEventListener('slideChanged', (event) => {
          this.mobileSlide = event.detail.currentElement;
          this.updateMobileHeight();
        });
        this.mobileResizeObserver = new ResizeObserver(this.updateMobileHeight);
        this.elements.viewer.querySelectorAll('.product-media-container').forEach((media) => {
          this.mobileResizeObserver.observe(media);
        });
        this.mql.addEventListener('change', this.updateMobileHeight);
        requestAnimationFrame(this.updateMobileHeight);
      }

      disconnectedCallback() {
        this.mobileResizeObserver?.disconnect();
        this.mql.removeEventListener('change', this.updateMobileHeight);
      }

      initCutGroups() {
        const data = this.querySelector('[data-pk-cut-groups]');
        this.cutStyle = this.querySelector('[data-pk-cut-style]');
        if (!data || !this.cutStyle) return;
        try {
          this.cutGroups = JSON.parse(data.textContent);
        } catch {
          return;
        }
        requestAnimationFrame(() => {
          this.applyCutGroup(this.cutGroups.selected);
          this.elements.viewer.resetPages?.();
          this.elements.thumbnails?.resetPages?.();
        });
      }

      applyCutGroup(cut) {
        if (!this.cutGroups || !cut) return;
        const section = this.cutGroups.section;
        const gallery = CSS.escape(this.id);
        const modal = CSS.escape('ProductModal-' + section);
        this.cutStyle.textContent = this.cutGroups.media
          .filter((media) => media.cut && media.cut !== cut)
          .map((media) => {
            const target = CSS.escape(section + '-' + media.id);
            const id = CSS.escape(media.id);
            return '#' + gallery + ' [data-media-id="' + target + '"],'
              + '#' + gallery + ' [data-target="' + target + '"],'
              + '#' + modal + ' [data-media-id="' + id + '"]{display:none!important}';
          }).join('\n');
        this.cutGroups.selected = cut;
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        if (prepend && this.cutGroups) {
          const group = this.cutGroups.media.find((media) => this.cutGroups.section + '-' + media.id === mediaId);
          if (group?.cut) this.applyCutGroup(group.cut);
        }
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');
        this.mobileSlide = activeMedia;
        requestAnimationFrame(this.updateMobileHeight);

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
          this.elements.thumbnails?.resetPages?.();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
      //  window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
